module.exports = __webpack_public_path__ + "static/img/sy_banner.f0e67a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/sy_banner.png
// module id = 0RR7
// module chunks = 1